import axios from 'axios';
import * as types from 'store/types';
import services from 'services/services';
import {
	CAR_DETAIL_URL,
	BOOKING_CREATE_URL,
	BOOKING_AND_PAYMENT_CREATE_URL
} from 'helpers';

export const getCar = (params, options) => async (dispatch) => {
	try {
		dispatch({
			type: types.CAR_DETAIL_FETCH_DATA_LOADING
		});

		const { data } = await services.post(
			CAR_DETAIL_URL(params.car_id),
			params,
			options
		);

		dispatch({
			type: types.CAR_DETAIL_FETCH_DATA_SUCCESS,
			payload: data
		});
	} catch (error) {
		if (axios.isCancel(error)) {
			return;
		}

		dispatch({
			type: types.CAR_DETAIL_FETCH_DATA_ERROR,
			payload: error
		});
	}
};

export const setCarParamsContext = (params) => async (dispatch) => {
	dispatch({
		type: types.CAR_PARAMS_SET_CONTEXT,
		payload: params
	});
};

export const resetCarParamsContext = () => async (dispatch) => {
	dispatch({
		type: types.CAR_PARAMS_RESET_CONTEXT
	});
};

export const bookAndPaidLater = (
	params,
	errorCallback,
	successCallback
) => async (dispatch) => {
	try {
		dispatch({
			type: types.BOOK_AND_PAID_LATER_LOADING
		});

		const { data } = await services.post(BOOKING_CREATE_URL, params);

		dispatch({
			type: types.BOOK_AND_PAID_LATER_SUCCESS,
			payload: data
		});
		successCallback(data);
	} catch (error) {
		errorCallback(error);
		dispatch({
			type: types.BOOK_AND_PAID_LATER_ERROR,
			payload: error
		});
	}
};

export const bookAndNowLater = (
	params,
	errorCallback,
	successCallback
) => async (dispatch) => {
	try {
		dispatch({
			type: types.BOOK_AND_PAID_LATER_LOADING
		});

		const { data } = await services.post(
			BOOKING_AND_PAYMENT_CREATE_URL,
			params
		);

		dispatch({
			type: types.BOOK_AND_PAID_LATER_SUCCESS,
			payload: data
		});
		successCallback(data);
	} catch (error) {
		errorCallback(error);
		dispatch({
			type: types.BOOK_AND_PAID_LATER_ERROR,
			payload: error
		});
	}
};

export const setRewardOptions = (payload) => async (dispatch) => {
	try {
		dispatch({
			type: types.SET_REWARD_OPTIONS_SUCCESS,
			payload
		});
	} catch (error) {
		dispatch({
			type: types.SET_REWARD_OPTIONS_ERROR,
			payload: error
		});
	}
};
